import http from "./httpService";

const API_PATH = "/api/pd/1.0.0";

export const getAppraisees = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/appraisees`, { headers, params });

    return data;
};

export const getAppraiseeDetails = async ({ uuid, serviceURL, accessToken, }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/appraisees/${uuid}`, { headers });

    return data;
};

export const getAppraisers = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/appraisers`, {headers, params });

    return data;
};

export const getAppraisals = async ({ serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/appraisals`, { headers });

    return data;
};

export const getAppraisalDetails = async ({ id, serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/appraisals/${id}`, { headers, params });

    return data;
};

export const initAppraisal = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/appraisals/initiate`, params, { headers });

    return data;
};

export const addAppraisal = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}`, "Content-Type": "multipart/form-data" };
    const formData = new FormData();
    formData.append("title", params.title);
    formData.append("appraiserName", params.appraiser[0]?.name);
    formData.append("appraiserEmail", params.appraiser[0]?.email);
    formData.append("cycleStart", params.cycle?.start);
    formData.append("meetingDate", params.meeting?.date);
    formData.append("meetingNotes", params.meeting?.notes);
    formData.append("originName", params.origin?.name);
    formData.append("originType", params.origin?.type);
    formData.append("originTemplate", params.origin?.template);
    formData.append("originSupplier", params.origin?.supplier);
    formData.append("importDate", params.import?.date);
    formData.append("importName", params.import?.name);
    formData.append("importMethod", params.import?.method);
    formData.append("importDocumentType", params.import?.documentType);
    if (!!params?.import?.file) {
        formData.append("importFile", params.import.file, params.import.file.name);
    }

    const { data } = await http.post(`${serviceURL}${API_PATH}/appraisals`, formData, { headers });

    return data;
};

export const updateAppraisal = async ({ id, params, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/appraisals/${id}`, params, { headers });

    return data;
};

export const addAppraisalForm = async ({ id, params, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/appraisals/${id}/forms`, params, { headers });

    return data;
};

export const updateAppraisalForm = async ({ id, formId, params, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/appraisals/${id}/forms/${formId}`, params, { headers });

    return data;
};

export const updateAppraisalFormElement = async ({ id, params, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/appraisals/${id}/formelements`, params, { headers });

    return data;
};

export const getActivities = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/activities`, { headers, params });

    return data;
};

export const getActivityDetails = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/activities/${id}`, { headers });

    return data;
};

export const addActivity = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/activities`, params, { headers });

    return data;
};

export const updateActivity = async ({ serviceURL, accessToken, id, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/activities/${id}`, params, { headers });

    return data;
};

export const deleteActivity = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/activities/${id}`, { headers });

    return data;
};

export const getActivityTypes = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/config/activities/types`, { headers, params });

    return data;
};

export const getQualifications = async ({ serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/qualifications`, { headers });

    return data;
};

export const getQualification = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/qualifications/${id}`, { headers });

    return data;
};

export const addQualification = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/qualifications`, params, { headers });

    return data;
};

export const updateQualification = async ({ serviceURL, accessToken, id, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/qualifications/${id}`, params, { headers });

    return data;
};

export const deleteQualification = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/qualifications/${id}`, { headers });

    return data;
};

export const getResources = async ({ type, serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/resources/${type}`, { headers, params });

    return data;
};

export const getResourceDetails = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/resources/${id}`, { headers });

    return data;
};

export const downloadResource = async ({ id, serviceURL, url, accessToken }) => {
    const downloadUrl = url || `${serviceURL}${API_PATH}/resources/${id}/download`;
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(downloadUrl, { headers, responseType: "blob" });

    return data;
};

export const addResource = async ({ serviceURL, accessToken, title, description, type, file }) => {
    const headers = { Authorization: `Bearer ${accessToken}`, "Content-Type": "multipart/form-data"};
    const formData = new FormData();
    formData.append("title", title);
    if (!!description) formData.append("description", description);
    if (!!type) {
        formData.append("type", type);
        if (type === "file" && !!file) formData.append("file", file, file.name);
    }
    const { data } = await http.post(`${serviceURL}${API_PATH}/resources`, formData, { headers });

    return data;
};

export const updateResource = async ({ serviceURL, accessToken, id, ...params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/resources/${id}`, params, { headers });

    return data;
};

export const deleteResource = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/resources/${id}`, { headers });

    return data;
};

export const getCategories = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/categories`, { headers, params });

    return data;
};

export const getContacts = async ({ serviceURL, accessToken, ...params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/contacts`, { headers, params });

    return data;
};

export const getMessages = async ({ folder, serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/messages/${folder}`, { headers, params });

    return data;
};

export const getMessageDetails = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/messages/${id}`, { headers });

    return data;
};

export const addMessage = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/messages`, params, { headers });

    return data;
};

export const updateMessage = async ({ serviceURL, accessToken, id, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/messages/${id}`, params, { headers });

    return data;
};

export const deleteMessage = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/messages/${id}`, { headers });

    return data;
};

export const getNotifications = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/alerts`, { headers, params });

    return data;
};

export const getNotificationDetails = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/alerts/${id}`, { headers });

    return data;
};

export const getScopeOfWorkDetails = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/scopeofworks/${id}`, { headers });

    return data;
};

export const addScopeOfWork = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/scopeofworks`, params, { headers });

    return data;
};

export const updateScopeOfWork = async ({ serviceURL, accessToken, id, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/scopeofworks/${id}`, params, { headers });

    return data;
};

export const deleteScopeOfWork = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/scopeofworks/${id}`, { headers });

    return data;
};

export const getPDPs = async ({ serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/pdps`, { headers });

    return data;
};

export const getPDPDetails = async ({ id, serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/pdps/${id}`, { headers, params });

    return data;
};

export const updatePDP = async ({ serviceURL, accessToken, id, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/pdps/${id}`, params, { headers });

    return data;
};

export const deletePDP = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/pdps/${id}`, { headers });

    return data;
};

export const getDevelopmentNeeds = async ({ serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/developmentneeds`, { headers });

    return data;
};

export const getDevelopmentNeed = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/developmentneeds/${id}`, { headers });

    return data;
};

export const addDevelopmentNeed = async ({ serviceURL, accessToken, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.post(`${serviceURL}${API_PATH}/developmentneeds`, params, { headers });

    return data;
};

export const updateDevelopmentNeed = async ({ serviceURL, accessToken, id, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/developmentneeds/${id}`, params, { headers });

    return data;
};

export const deleteDevelopmentNeed = async ({ id, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.delete(`${serviceURL}${API_PATH}/developmentneeds/${id}`, { headers });

    return data;
};

export const getTasks = async ({ serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/tasks`, { headers });

    return data;
};

export const getTerms = async ({ serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.get(`${serviceURL}${API_PATH}/terms`, { headers });

    return data;
};

export const updateTerm = async ({ serviceURL, accessToken, id, params }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/terms/${id}`, params, { headers });

    return data;
};

export const updateSurvey = async ({ id, params, serviceURL, accessToken }) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    const { data } = await http.put(`${serviceURL}${API_PATH}/surveys/${id}`, params, { headers });

    return data;
};

const rmsService = {
    getAppraisees,
    getAppraiseeDetails,
    getAppraisers,
    getAppraisals,
    getAppraisalDetails,
    initAppraisal,
    addAppraisal,
    updateAppraisal,
    addAppraisalForm,
    updateAppraisalForm,
    updateAppraisalFormElement,
    getActivities,
    getActivityDetails,
    addActivity,
    updateActivity,
    deleteActivity,
    getActivityTypes,
    getCategories,
    getContacts,
    getMessages,
    getMessageDetails,
    addMessage,
    updateMessage,
    deleteMessage,
    getNotifications,
    getNotificationDetails,
    getPDPs,
    getPDPDetails,
    updatePDP,
    deletePDP,
    getDevelopmentNeeds,
    getDevelopmentNeed,
    addDevelopmentNeed,
    updateDevelopmentNeed,
    deleteDevelopmentNeed,
    getQualifications,
    getQualification,
    addQualification,
    updateQualification,
    deleteQualification,
    getResources,
    getResourceDetails,
    downloadResource,
    addResource,
    updateResource,
    deleteResource,
    getScopeOfWorkDetails,
    addScopeOfWork,
    updateScopeOfWork,
    deleteScopeOfWork,
    getTasks,
    getTerms,
    updateTerm,
    updateSurvey,
};

export default rmsService;
